import React, { Component } from 'react';
import Modal from 'react-responsive-modal';

class FullScreenModal extends Component {
  constructor(props) {
    super(props);
    this.style = {
      modal: {
        padding: '30px',
        borderRadius: '5px',
        textAlign: 'center',
      },
    }
  }

  render() {
    return (
      <Modal open={this.props.open} onClose={this.props.onClose} styles={this.style} showCloseIcon={false}>
        {this.props.children}
      </Modal>
    );
  }
}

export default FullScreenModal;


// WEBPACK FOOTER //
// ./src/Components/common/FullScreenModal.js